export default "__VITE_ASSET__BU28JGiP__"